import React, { useEffect } from "react";
import { useState } from "react";
import { Icon } from '@iconify/react';
import Modal from "../../components/modal";
import Button from "../../components/button"
import Headline5 from "../../components/headings/Headline5";
import Styles from "./styles.module.scss";
import { submitProfilePicture , getBasicProfileValues } from './services'
import CropPopup from './cropPopup'


interface props {
  onClose?: any;
}

const ProfilePicture: React.FC<props> = ({
  onClose,
}) =>  {

const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  
const loginId = localStorage.getItem('loginId')
const [modal, setModal] = useState<boolean>(false)
const [profileImage , setProfileImage] = useState<any>()


useEffect(() =>{
  const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  setProfileImage(profileMetadata.image ? profileMetadata.image : " ")
},[])

const uploadPicture = () =>{
  setModal(true)
} 

const removePicture = () => {
  setProfileImage(" ")
}

const savePicture = () =>{  
  let  value = {
    "loginId": loginId,
    "profileMetadata": {
    "image":  " "
    }
  }  
  submitProfilePicture(value).then((response) => {
    if(response.status === "1"){
      getBasicProfileValues(loginId).then((response) => {
        if(response.status === "1"){
            localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profile_metadata))
            setProfileImage(response.data[0].profile_metadata.image)
            onClose()
        }
      })  
    } 
  })
}
 
return (
    <>
      <Modal title={" "} size="small" onClose={onClose}>
        <Headline5>Change your profile picture</Headline5>
        <div className={Styles.imageUploadWrap}>
            <div className={Styles.uploadOptions}>
              <button  onClick={uploadPicture}><Icon icon="lucide:upload"/>Upload picture</button>
              <button className={Styles.delete} onClick={removePicture}><Icon icon="material-symbols:delete-outline-rounded" />Remove picture</button>
            </div>
            { 
              profileImage && profileImage === " " ? 
              <figure>{ profileMetadata.firstName[0]} {profileMetadata.lastName[0]}</figure>  : 
              <figure><img src={profileImage} alt='profImage'/></figure> 
            }
        </div>
        <div className="popupAction">
            <Button onClick={onClose} variant="secondary">Close</Button>
            <Button onClick={savePicture} variant="primary">Save</Button>
        </div>
        {modal && <CropPopup onClose={onClose} profileImage={profileImage}/>}
      </Modal>
    </>
  )
}
export default ProfilePicture

